// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2JzjB","inner":"Footer_inner__1EHLf"};